import "./Header.less";

import $ from "jquery";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import i18n from "i18next";
import { translate } from "react-i18next";
import config from "../../config";

import { POSSIBLE_LANGUAGES } from "../../constants/languages";

const LANGUAGES = POSSIBLE_LANGUAGES.map(lang => lang.toUpperCase());

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedLanguage: i18n.language.toUpperCase()
		};
	}

	languageSelectorClickHandler(event) {
		event.preventDefault();
		const selectedLanguage = this.getSelectableLanguage();

        this.switchLanguage(selectedLanguage);
	}

    switchLanguage(language) {
        //var url = window.location.href;

        //if (url.indexOf('lang=') >= 0) {
        //    url = url.replace(/lang=([^?&#]+)/g, 'lang=' + language);
        //}
        //else {
        //    var prefix = url.indexOf('?') >= 0 ? '&' : '?';

        //    if (url.indexOf('#') >= 0) {
        //        url = url.replace('#', prefix + 'lang=' + language + '#');
        //    }
        //    else {
        //        url += prefix + 'lang=' + language;
        //    }
        //}

        $.post('/config/switchlanguage?culture=' + language.toLowerCase(), {}, () => {
            i18n.changeLanguage(language.toLowerCase());
			this.setState({ selectedLanguage: language });
			config.language = language.toLowerCase();
        });
    }

	getSelectedLanguage() {
		return this.state.selectedLanguage;
	}

	getSelectableLanguage() {
		return LANGUAGES[(LANGUAGES.findIndex(language => language === this.getSelectedLanguage()) + 1) % 2];
	}

	getContactUrl() {
		const language = this.getSelectedLanguage();
		return language === 'FR' 
			? 'https://www.plantyn.com/fr-BE/contact'
			: 'https://www.plantyn.com/contact';
	}

	render() {
		const t = this.props.t;

		return (
			<nav className="navbar navbar-expand-lg navbar-light">
				<Link className="navbar-brand" to="/" />
				<button
					className="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<span className="navbar-toggler-icon" />
				</button>

				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul>
						{/* 
						<li className="nav-item active">
							<a className="nav-link" href="#">
								{t("primary")} <span className="sr-only">(current)</span>
							</a>
						</li>
						<li className="nav-item active">
							<a className="nav-link" href="#">
								{t("secondary")} <span className="sr-only">(current)</span>
							</a>
						</li>
						*/}
						<li className="nav-item active">
							<a className="nav-link" href={this.getContactUrl()} target="_blank" rel="noopener noreferrer">
								{t("contactUs")} <span className="sr-only">(current)</span>
							</a>
						</li>
					</ul>
					<ul className="language-dropdown">
						<li className="nav-item dropdown">
							<a
								className="nav-link dropdown-toggle"
								href="#"
								id="navbarDropdown"
								role="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								{this.getSelectedLanguage()}
							</a>
							<div className="dropdown-menu" aria-labelledby="navbarDropdown">
								<a className="dropdown-item" href="#" onClick={this.languageSelectorClickHandler.bind(this)}>
									{this.getSelectableLanguage()}
								</a>
							</div>
						</li>
					</ul>
				</div>
			</nav>
		);
	}
}

const translateHeader = translate("header")(Header);

export { translateHeader as Header };



// WEBPACK FOOTER //
// ./src/components/Header/Header.js